export const FETCH_FLEET_CATEGORY_REQUEST = "FETCH_FLEET_CATEGORY_REQUEST";
export const FETCH_FLEET_CATEGORY_SUCCESS = "FETCH_FLEET_CATEGORY_SUCCESS";
export const FETCH_FLEET_CATEGORY_FAILURE = "FETCH_FLEET_CATEGORY_FAILURE";

export const FETCH_FLEET_REQUEST = "FETCH_FLEET_REQUEST";
export const FETCH_FLEET_SUCCESS = "FETCH_FLEET_SUCCESS";
export const FETCH_FLEET_FAILURE = "FETCH_FLEET_FAILURE";

